import { UploadFile } from "../../app/models/classes/upload-file.class";

const isSameUploadFile = (a: UploadFile | null, b: UploadFile | null): boolean => {
  if (a === b) {
    return true;
  }

  if (!a || !b) {
    return false;
  }

  return a.file === b.file;
};

const isUploadFileOrNull = (value: unknown): value is UploadFile | null => {
  return value == null || value instanceof UploadFile;
};

export const compareValues = (valueA: any, valueB: any): number => {
  if (typeof valueA === "string" && typeof valueB === "string") {
    if (valueA === valueB) {
      return 0;
    }
    return valueA.localeCompare(valueB);
  }

  if (isUploadFileOrNull(valueA) && isUploadFileOrNull(valueB) && isSameUploadFile(valueA, valueB)) {
    return 0;
  }

  // handle nulls or undefined
  if (valueA == null && valueB == null) {
    return 0;
  }
  if (valueA == null) {
    return -1;
  }
  if (valueB == null) {
    return 1;
  }

  // handle booleans
  if (typeof valueA === "boolean" && typeof valueB === "boolean") {
    if (valueA === valueB) {
      return 0;
    }
    return valueA ? -1 : 1;
  }

  // handle numbers or strings
  if (valueA < valueB) {
    return -1;
  }
  if (valueA > valueB) {
    return 1;
  }

  return 0;
};
